import type { UserVerificationProcessApi } from 'api-typings/users/users';
import type { UserVerificationProcess } from './user-verification-processes.model';

export function transformUserVerificationProcess(
  userVerificationProcessApi: UserVerificationProcessApi,
): UserVerificationProcess {
  return {
    id: userVerificationProcessApi.id,
    verificationProcessTypeId:
      userVerificationProcessApi.verification_process_type_id,
    ownerId: userVerificationProcessApi.owner_id,
    status: userVerificationProcessApi.status,
    dateCreated: userVerificationProcessApi.date_created
      ? userVerificationProcessApi.date_created * 1000
      : 0, // Default to 0 because datastore does not support sorting on optional values
    dateModified: userVerificationProcessApi.date_modified
      ? userVerificationProcessApi.date_modified * 1000
      : userVerificationProcessApi.date_created
        ? userVerificationProcessApi.date_created * 1000
        : 0, // Default to 0 because datastore does not support sorting on optional values
    userDocumentSubmissionId:
      userVerificationProcessApi.user_document_submission_id ?? undefined,
  };
}
